import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import Typography from '@mui/material/Typography';
import { getTranslation } from '../../../../utils/translations';
import translations from './translations';
import SubmitButton from '../../../../components/molecules/SubmitButton';
import { Spacer } from '../../../../uikit/misc/Spacer';
import { ENDPOINTS } from '../../../../../types/endpoints';
import { KNOWN_QUERY_PARAMS } from '../../../../../server/services/QueryInputService/QueryInputService.types';
import { miscSlice } from '../../../../store/misc/misc.slice';
var t = getTranslation(translations);
var mapDispatchToProps = function (dispatch) { return ({
    redirectAppToPage: function (url) {
        return dispatch(miscSlice.actions.redirectAppToPage(url));
    },
}); };
export var RawRefusedLeadPage = function (_a) {
    var redirectAppToPage = _a.redirectAppToPage;
    var handleButtonClick = useCallback(function () {
        var _a = window.location, origin = _a.origin, search = _a.search;
        var url = new URL("".concat(origin).concat(ENDPOINTS.MORTGAGE_ROUTE_2).concat(search));
        url.searchParams.set(KNOWN_QUERY_PARAMS.AMOUNT, '300000');
        url.searchParams.set(KNOWN_QUERY_PARAMS.UTM_SOURCE, 'mortgage');
        url.searchParams.set(KNOWN_QUERY_PARAMS.UTM_MEDIUM, 'onsite');
        url.searchParams.set(KNOWN_QUERY_PARAMS.UTM_CAMPAIGN, 'regret');
        url.searchParams.set(KNOWN_QUERY_PARAMS.PREVENT_SWITCH, '1');
        url.searchParams.set(KNOWN_QUERY_PARAMS.REDIRECTED_FROM_MR1, '1');
        redirectAppToPage(String(url));
    }, [redirectAppToPage]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: 'h4' }, t.title),
        React.createElement(Spacer, { size: 2 }),
        React.createElement(Typography, null, t.description),
        React.createElement(Spacer, { size: 3 }),
        React.createElement(SubmitButton, { text: t.btnTitle, onClick: handleButtonClick })));
};
export var RefusedLeadPage = connect(null, mapDispatchToProps)(RawRefusedLeadPage);
